import React from 'react';
import {
  ListOrdered, Smartphone, Tv, Monitor, Layers, CloudOff, FileText, Wand2, Search, Sparkles,
} from 'lucide-react';
import { APP_VERSION } from '../version';

const FEATURES = [
  { icon: ListOrdered, title: 'Service run-sheet', text: 'Plan scriptures, songs and slides ahead, then step through them with the arrow keys.' },
  { icon: Smartphone, title: 'Phone remote', text: 'Scan a QR code and a volunteer can run the slides from their phone. No password shared.' },
  { icon: Tv, title: 'Livestream for OBS', text: 'Verses and lyrics appear as a lower third on your stream while you are live.' },
  { icon: Monitor, title: 'Stage screen', text: 'The preacher and band see the current slide, the next one, the next item and a clock.' },
  { icon: Layers, title: 'Slides that fit', text: 'Long passages split by sentence; songs show one to four lines at a time.' },
  { icon: Search, title: 'Browse books', text: 'Pick a book, chapter and verses by clicking, with next and previous chapter.' },
  { icon: CloudOff, title: 'Offline and in sync', text: 'Keeps working if the internet drops, and your data follows your login to any computer.' },
  { icon: FileText, title: 'CCLI song reports', text: 'See how often each song was shown and download a report for your licence.' },
  { icon: Wand2, title: 'Sermon notes', text: 'Summary, discussion questions and a printable handout you can save as PDF.' },
];

/** The "New in 2.0" section of the front page. Always on the dark landing background. */
const WhatsNewSection = ({ onTour, onChangelog }) => (
  <section id="whats-new" className="px-6 py-20" aria-label={`New in version ${APP_VERSION}`}>
    <div className="max-w-7xl mx-auto">
      <div className="text-center mb-12">
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-600/20 border border-emerald-500/40 text-emerald-300 text-sm font-semibold mb-4">
          <Sparkles className="w-4 h-4" /> New in version 2.0
        </span>
        <h3 className="text-4xl font-bold text-slate-50 mb-4">Run the whole service from one place</h3>
        <p className="text-slate-300 text-lg max-w-3xl mx-auto">
          Plan it, show it, control it from a phone, put it on your stream, and have it all ready on any computer.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {FEATURES.map(({ icon: Icon, title, text }) => (
          <div key={title} className="bg-slate-800 rounded-xl p-6 border border-slate-700 shadow-lg">
            <div className="p-3 bg-emerald-600 rounded-lg w-fit mb-4">
              <Icon className="w-7 h-7 text-slate-50" />
            </div>
            <h4 className="text-xl font-bold text-slate-50 mb-2">{title}</h4>
            <p className="text-slate-300 leading-relaxed">{text}</p>
          </div>
        ))}
      </div>

      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
        <button
          onClick={onTour}
          className="px-8 py-4 bg-slate-800 border border-slate-700 text-slate-50 rounded-xl hover:bg-slate-700 font-bold text-lg transition-all"
        >
          Take the tour
        </button>
        <button
          onClick={onChangelog}
          className="px-8 py-4 bg-transparent border border-slate-600 text-slate-200 rounded-xl hover:bg-slate-800 font-bold text-lg transition-all"
        >
          See the full change log
        </button>
      </div>
    </div>
  </section>
);

export default WhatsNewSection;
